







































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { RepaymentPageRecord, CollectionRequest, RepaymentState, IsExtends, DoubleLoan, PersonalOperate } from '@/api/model/repayment'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import SpecialVietForm from './form/SpecialVietForm.vue'
import ManualForm from './form/ManualForm.vue'
import PartialForm from './form/PartialForm.vue'
import SubstractForm from './form/SubstractForm.vue'
import SettlementForm from './form/SettlementForm.vue'
import ExtendsForm from './form/ExtendsForm.vue'
import GenerateReturnCodeDialog from '../../../receipt/repayment/GenerateReturnCodeDialog.vue'
import $Api from '@api'
import { translate, DateTime } from '@/utils/filters'
import { finalize } from 'rxjs/operators'
import { mergedRepaymentSelectionError, selectedRepaymentIds } from '@/utils/merged-repayment-selection'

const repaymentStateOption: { label: string; value: RepaymentState }[] = [
    {
        label: translate('repayment.state.unpaid'),
        value: RepaymentState.UNPAID
    },
    {
        label: translate('repayment.state.normal'),
        value: RepaymentState.NORMAL
    },
    {
        label: translate('repayment.state.overdue'),
        value: RepaymentState.OVERDUE
    },
    {
        label: translate('repayment.state.afterOverdue'),
        value: RepaymentState.AFTER_OVERDUE
    },
    // {
    //     label: translate('repayment.state.partial'),
    //     value: RepaymentState.PARTIAL
    // },
    // {
    //     label: translate('repayment.state.afterPartial'),
    //     value: RepaymentState.AFTER_PARTIAL
    // },
    {
        label: translate('repayment.state.manual'),
        value: RepaymentState.MANUAL
    },
    {
        label: translate('repayment.state.cancel'),
        value: RepaymentState.CANCEL
    }
]

const isExtendsOption: { label: string; value: IsExtends }[] = [
    {
        label: translate('repayment.isExtends.notExtends'),
        value: IsExtends.NOT_EXTENDS
    },
    {
        label: translate('repayment.isExtends.extending'),
        value: IsExtends.EXTENDING
    },
    {
        label: translate('repayment.isExtends.extends'),
        value: IsExtends.EXTENDSUCCESS
    }
]

const doubleLoanOption: { label: string; value: DoubleLoan }[] = [
    {
        label: translate('repayment.doubleLoan.first'),
        value: DoubleLoan.FIRST
    },
    {
        label: translate('repayment.doubleLoan.double'),
        value: DoubleLoan.DOUBLE
    }
]

const personalOperateOption: { label: string; value: PersonalOperate }[] = [
    {
        label: translate('repayment.doubleLoan.first'),
        value: PersonalOperate.SELF
    },
    {
        label: translate('repayment.doubleLoan.double'),
        value: PersonalOperate.ALL
    }
]

@Component({
    components: {
        SearchForm,
        TableForm,
        SettlementForm,
        ExtendsForm,
        ManualForm,
        PartialForm,
        SubstractForm,
        SpecialVietForm,
        GenerateReturnCodeDialog
    },
    filters: {
        getRepaymentState(state: RepaymentState) {
            const item = repaymentStateOption.find(option => option.value === state)
            if (item) {
                return item.label
            }
            return state
        },
        getIsExtends(state: IsExtends) {
            const item = isExtendsOption.find(option => option.value === state)
            if (item) {
                return item.label
            }
            return state
        },
        getDoubleLoan(state: DoubleLoan) {
            const item = doubleLoanOption.find(option => option.value === state)
            if (item) {
                return item.label
            }
            return state
        },
        getPersonalOperate(state: PersonalOperate) {
            const item = personalOperateOption.find(option => option.value === state)
            if (item) {
                return item.label
            }
            return state
        }
    }
})
export default class extends Vue {
    tableData: RepaymentPageRecord[] = []
    total = 0

    updateCollectionStatusVisible = false
    // 0入催 1出催 2暂停
    curCollectionFlag = 0
    collectionData: CollectionRequest = {
        mid: 0,
        cameraId: 0,
        remark: ''
    }

    defaultTime = ['00:00:00', '23:59:59']
    shouldTimeDateValue = null
    finishTimeDateValue = null
    operateTimeDateValue = null

    shouldTableDataLoading = false

    manualFormVisible = false
    partialFormVisible = false
    substractFormVisible = false
    settlementFormVisible = false
    extendsFormVisible = false
    specialVietVisible = false
    mergedRepaymentCodeVisible = false
    mergedRepaymentCameraId = ''

    manualButtonVisible = false
    partialButtonVisible = false
    settlementButtonVisible = false
    extendsButtonVisible = false
    substractButtonVisible = false
    vietButtonVisible = false
    privileges = this.$store.getters.privileges

    currentRecord: RepaymentPageRecord | null = null
    multipleSelection: RepaymentPageRecord[] = []

    formEl: any

    searchForm: { [key: string]: any } = {
        current: 1,
        size: 10,
        cameraIdStr: null,
        shouldTimeBegin: null,
        shouldTimeEnd: null,
        finishTimeBegin: null,
        finishTimeEnd: null,
        repayState: null,
        phone: null,
        cardNo: null,
        userName: null,
        doubleLoan: null,
        personalOperateOption: null
    }

    repaymentStateOption = repaymentStateOption
    doubleLoanOption = doubleLoanOption
    personalOperateOption = personalOperateOption

    repayStates = [
        {
            name: translate('repayment.state.unpaid'),
            value: 1
        },
        {
            name: translate('repayment.state.repaid'),
            value: 2
        }
    ]

    showTestClick = false

    created(): void {
        const { phone = '' } = this.$route.query
        this.searchForm.phone = phone
        this.getData()
        // console.log("获取权限数据-->",this.privileges);
        this.manualButtonVisible = this.privileges.includes('FC-UNPAID-OPERATE-MANUAL')
        this.partialButtonVisible = this.privileges.includes('FC-PARTIAL-BUT')
        this.settlementButtonVisible = this.privileges.includes('FC-SETTLE-BUT')
        this.extendsButtonVisible = this.privileges.includes('FC-EXTENDS-BUT')
        this.substractButtonVisible = this.privileges.includes('FC-SUBSTRACT-BUT')
        this.vietButtonVisible = this.privileges.includes('FC-MERGE-BUT')
    }

    onSearchSubmit(): void {
        this.searchForm.current = 1
        this.getData()
    }

    getData(pageQuery?: object): void {
        if (pageQuery) {
            Object.assign(this.searchForm, pageQuery)
        }
        this.shouldTableDataLoading = true
        const formData = this.clearEmptyProperty(this.searchForm)
        $Api.repaymentService
            .repaymentPage(formData)
            .pipe(
                finalize(() => {
                    this.shouldTableDataLoading = false
                })
            )
            .subscribe(res => {
                this.tableData = res.records
                this.total = res.total
                this.$forceUpdate()
            })
    }

    onTestclick() {
        console.log(JSON.stringify(this.tableData, null, 2))
        let tableDataLocal = this.tableData
        this.tableData = []
        for (let i = 0; i < tableDataLocal.length; i++) {
            this.tableData.push(tableDataLocal[i])
        }
    }

    onVietClick() {
        this.specialVietVisible = true
        const [currentRecord] = this.multipleSelection
        this.$nextTick(() => {
            ;(this.$refs['specialViet'] as any).fetchData(currentRecord)
        })
    }

    onExtendsClick() {
        const [currentRecord] = this.multipleSelection
        this.extendsFormVisible = true

        this.$nextTick(() => {
            ;(this.$refs['extendsForm'] as any).fetchData(currentRecord)
        })
    }

    onCardNoChange(value: string | number) {
        if (+value === 9527) {
            this.showTestClick = true
        }
    }

    handleCommand(command: string): void {
        const [currentRecord] = this.multipleSelection

        switch (command) {
            case 'action-manual': {
                this.manualFormVisible = true

                this.$nextTick(() => {
                    ;(this.$refs['manualForm'] as any).fetchData(currentRecord)
                })

                break
            }

            case 'action-partial':
                this.partialFormVisible = true

                this.$nextTick(() => {
                    ;(this.$refs['partialForm'] as any).fetchData(currentRecord)
                })

                break

            case 'action-substract':
                this.substractFormVisible = true

                this.$nextTick(() => {
                    ;(this.$refs['substractForm'] as any).fetchData(currentRecord)
                })

                break

            case 'action-settlement':
                this.settlementFormVisible = true

                this.$nextTick(() => {
                    ;(this.$refs['settlementForm'] as any).fetchData(currentRecord)
                })

                break

            case 'action-result':
                this.$router.push({ path: '/repayment/unpaid/result' })

                break

            case 'action-extends':
                this.onExtendsClick()

                break
        }
    }

    handleSelectionChange(records: RepaymentPageRecord[]): void {
        this.multipleSelection = records
    }

    get mergedRepaymentIds(): string[] {
        return selectedRepaymentIds(this.multipleSelection)
    }

    openMergedRepaymentCodeDialog(): void {
        const [first] = this.multipleSelection
        if (!first) return
        const errorKey = mergedRepaymentSelectionError(this.multipleSelection)
        if (errorKey) {
            this.$message.warning(translate(errorKey))
            return
        }
        this.mergedRepaymentCameraId = first.cameraIdStr || String(first.cameraId)
        this.mergedRepaymentCodeVisible = true
    }

    onMergedRepaymentCodeCreated(): void {
        this.getData()
    }

    clearEmptyProperty(source: any): any {
        const cloneSource = Object.assign({}, source)
        Object.keys(cloneSource).forEach(key => {
            if (cloneSource[key] === '' || cloneSource[key] === null) {
                delete cloneSource[key]
            }
        })
        return cloneSource
    }

    onFormReset(): void {
        // The resetFields method (from SearchForm.vue) does not take effect on datePicker, need to reset manually
        this.finishTimeDateValue = null
        this.shouldTimeDateValue = null
        this.operateTimeDateValue = null
    }

    reset(formName: string): void {
        ;(this.$refs[formName] as Form).resetFields()
    }

    @Watch('shouldTimeDateValue')
    onShouldTimeDateValueChange(date: [Date, Date]): void {
        if (!date) {
            this.searchForm.shouldTimeBegin = null
            this.searchForm.shouldTimeEnd = null
        } else {
            const [startTime, endTime] = date
            this.searchForm.shouldTimeBegin = startTime.getTime()
            this.searchForm.shouldTimeEnd = endTime.getTime()
        }
    }

    @Watch('finishTimeDateValue')
    onFinishTimeDateValueChange(date: [Date, Date]): void {
        if (!date) {
            this.searchForm.finishTimeBegin = null
            this.searchForm.finishTimeEnd = null
        } else {
            const [startTime, endTime] = date
            this.searchForm.finishTimeBegin = startTime.getTime()
            this.searchForm.finishTimeEnd = endTime.getTime()
        }
    }

    @Watch('operateTimeDateValue')
    onOperateTimeDateValueChange(date: [Date, Date]): void {
        if (!date) {
            this.searchForm.operateTimeBegin = null
            this.searchForm.operateTimeEnd = null
        } else {
            const [startTime, endTime] = date
            this.searchForm.operateTimeBegin = startTime.getTime()
            this.searchForm.operateTimeEnd = endTime.getTime()
        }
    }

    dateTime(time) {
        if (time) return DateTime(time)
        return ''
    }

    get country() {
        return (this.$store.state.auth.authInfo || {}).country
    }

    viewReceiptDetail({ cameraId }: RepaymentPageRecord) {
        const query = { cameraId: String(cameraId), from: 'repayment-unpaid-record' }
        this.$router.push({ path: '/repayment/unpaid/result', query })
    }

    dealWithCollection(row) {
        this.curCollectionFlag = row.collectFlag
        this.collectionData = {
            mid: row.customerId,
            cameraId: row.cameraId,
            remark: ''
        }
        this.updateCollectionStatusVisible = true
    }

    onCheckingSubmit(type) {
        if (type === 0) {
            this.updateCollectionStatusVisible = false
            return
        }
        // 0入催 1出催 2暂停
        if (this.curCollectionFlag === 2) {
            $Api.repaymentService.resumeCollection({
                mid: this.collectionData.mid,
                cameraId: this.collectionData.cameraId,
                remark: this.collectionData.remark,
            })
            .subscribe(() => {
                this.$message({
                    message: translate('common.success'),
                    type: 'success'
                })
                this.updateCollectionStatusVisible = false
                this.getData()
            })
        } else {
            $Api.repaymentService.pauseCollection({
                mid: this.collectionData.mid,
                cameraId: this.collectionData.cameraId,
                remark: this.collectionData.remark,
            })
            .subscribe(() => {
                this.$message({
                    message: translate('common.success'),
                    type: 'success'
                })
                this.updateCollectionStatusVisible = false
                this.getData()
            })
        }
    }

    viewRepaymentDetail(row: RepaymentPageRecord): void {
        $Api.repaymentService
            .repaymentInfo({
                index: row.indexs,
                lid: row.lid
            })
            .subscribe(data => {
                if (data !== null) {
                    const query = {
                        index: String(row.indexs),
                        lid: String(row.lid),
                        rid: String(data.rid)
                    }
                    this.$router.push({ path: '/repayment/unpaid/detail', query })
                }
            })
    }
}
